import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { NoticeListsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const noticeListsQuery = graphql(`
  query noticeLists {
    noticeLists {
      id
      guid
      name
      recordCount
      isOwner
      owner {
        guid
        firstName
        lastName
      }
    }
  }
`);

/** A company notice list. `isOwner` says whether the current user owns it. */
export type NoticeListSummary = NoticeListsQuery["noticeLists"][number];

/** The parts of a list the mutation hooks need for tracking. */
export type NoticeListIdentity = Pick<NoticeListSummary, "id" | "name">;

/** The company's notice lists that have an owner, most notices first. */
export function useNoticeLists(
  options?: UseQueryOptions<NoticeListsQuery, unknown, NoticeListsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["noticeLists"], noticeListsQuery, [], options);
  return { data: data?.noticeLists, ...rest };
}
